import { useState } from 'react';
import {
	useLazyCasesAssignedQuery,
	useLazyWorkplaceCasesQuery,
} from '../../../graphql/graphql';

export default function useCases(
	getWorkplaceCasesQuery: any,
	customSkip?: number,
) {
	const [page, setPage] = useState(1);
	const getWorkplaceCases = (filter: object) => {
		const skip = customSkip ?? 20;
		getWorkplaceCasesQuery({
			...filter,
			skip: (page - 1) * skip,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getWorkplaceCases, getNextPage, page, setPage };
}
